{
  "dateFormat": "{{year}} 年 {{month}} 月 {{date}} 日"
}
